import { Auth } from '@aws-amplify/auth';
import config from '@iotv/config';
import { DeleteObjectCommand, GetObjectCommand, ListObjectsV2Command, PutObjectCommand, S3Client, } from '@aws-sdk/client-s3';
import { unzipMappedBuffer } from '@iotv/s3';
import { deleteExact } from '../../../daoFunctions/daoFunctions';
const debug = process.env.REACT_APP_DEBUG && false;
const unzipMappedBufferWrapper = async (buffer, encoding) => {
    const unZipRes = await unzipMappedBuffer(buffer, encoding);
    if (unZipRes.err) {
        console.log(`Err unzipping (abdriged) `, buffer.toString().substring(0, 100), unZipRes.err.message);
    }
    return unZipRes.data;
};
export const s3ListWithCors = async (Prefix, bucketIdentifier, ContinuationToken) => {
    const credentials = await Auth.currentCredentials();
    const options = {
        region: config.aws.default_region,
        credentials: Auth.essentialCredentials(credentials),
        requestChecksumCalculation: 'WHEN_REQUIRED',
    };
    const s3 = new S3Client(options);
    const params = {
        Bucket: bucketIdentifier,
        Prefix,
        ContinuationToken,
    };
    debug && console.log('List params for s3', params);
    const res = { err: null, data: null };
    try {
        res.data = await s3.send(new ListObjectsV2Command(params));
    }
    catch (e) {
        res.err = new Error(` Err listing objects from s3 with prefix ${Prefix} in bucket ${bucketIdentifier}: ` + e.message);
    }
    return res;
};
const s3GetWithCors = async (Key, bucketIdentifier) => {
    const credentials = await Auth.currentCredentials();
    const options = {
        region: config.aws.default_region,
        credentials: Auth.essentialCredentials(credentials),
        requestChecksumCalculation: 'WHEN_REQUIRED',
    };
    const s3 = new S3Client(options);
    const params = {
        Bucket: bucketIdentifier,
        Key,
    };
    debug && console.log('Get params for s3', params);
    const res = { err: null, data: null };
    try {
        res.data = await s3.send(new GetObjectCommand(params));
    }
    catch (e) {
        res.err = new Error(` Err getting object from s3 with key ${Key} in bucket ${bucketIdentifier}: ` + e.message);
    }
    return res;
};
export const s3PutWithCors = async (Key, bucketIdentifier, object, Expires, Metadata) => {
    const credentials = await Auth.currentCredentials();
    const options = {
        region: config.aws.default_region,
        credentials: Auth.essentialCredentials(credentials),
        requestChecksumCalculation: 'WHEN_REQUIRED',
    };
    const s3 = new S3Client(options);
    debug && console.log('Options for s3', { options, Key, bucketIdentifier, object });
    const data = JSON.stringify(object);
    const params = {
        Bucket: bucketIdentifier,
        Key,
        Body: new Blob([data], { type: 'application/json' }),
        ContentType: 'application/json',
        Expires,
        Metadata,
    };
    const res = { err: null, data: null };
    try {
        res.data = await s3.send(new PutObjectCommand(params));
    }
    catch (e) {
        console.log('Err in s3PutWithCors with data', data, e.stack);
        res.err = new Error(` Err putting object to s3 with key ${Key} in bucket ${bucketIdentifier}: ` + e.message);
    }
    return res;
};
export const getObjectFromS3 = async ({ Key, bucketIdentifier }) => {
    let res = { err: null, data: null };
    let existingObject = null;
    const exisitingObjectResponse = await s3GetWithCors(Key, bucketIdentifier);
    if (exisitingObjectResponse.data?.Body) {
        const zipped = exisitingObjectResponse.data.ContentType === 'application/zip';
        let buffer = undefined;
        if (exisitingObjectResponse.data.Body instanceof Buffer) {
            buffer = exisitingObjectResponse.data.Body;
            console.log('Warn S3 sdk v3 migration, type check of Buffer may not be correct');
        }
        else if (exisitingObjectResponse.data.Body instanceof ReadableStream) {
            console.log('Warn S3 sdk v3 migration, type check of Readble may not be correct');
            const stream = exisitingObjectResponse.data.Body;
            const response = new Response(stream);
            buffer = Buffer.from(await response.arrayBuffer());
        }
        else {
            console.log('Warn S3 sdk v3 migration, type check of ??? may not be correct');
            debug && console.log('received', exisitingObjectResponse.data?.Body);
        }
        if (buffer) {
            existingObject = await s3BodyToObject(buffer, zipped);
            if (existingObject)
                res.data = existingObject;
        }
        if (existingObject)
            res.data = existingObject;
        debug && console.log('S3 getObjectFromS3 existingObject', { existingObject });
    }
    else {
        res.err = exisitingObjectResponse.err;
    }
    return res;
};
export const s3BodyToObject = async (body, zipped = false) => zipped ? await unzipMappedBufferWrapper(body) : JSON.parse(body.toString('utf-8'));
const deleteS3Object = async ({ Bucket, Key }) => {
    const credentials = await Auth.currentCredentials();
    const options = {
        region: config.aws.default_region,
        credentials: Auth.essentialCredentials(credentials),
        requestChecksumCalculation: 'WHEN_REQUIRED',
    };
    const s3 = new S3Client(options);
    const deleteRes = { err: null, data: null };
    try {
        deleteRes.data = await s3.send(new DeleteObjectCommand({ Bucket, Key }));
    }
    catch (e) {
        deleteRes.err = e;
    }
    return deleteRes;
};
export const deleteObjectHistory = async (objectHistory) => {
    const res = { err: null, data: null };
    if (objectHistory.metadata?.s3) {
        const { bucketIdentifier: Bucket, key: Key } = objectHistory.metadata.s3;
        const s3DeleteRes = await deleteS3Object({ Bucket, Key });
        if (s3DeleteRes.data) {
            const databaseDeleteRes = await deleteExact(objectHistory);
            if (databaseDeleteRes.data) {
                res.data = databaseDeleteRes.data;
            }
            else if (databaseDeleteRes.err) {
                res.err = databaseDeleteRes.err;
            }
        }
        else if (s3DeleteRes.err) {
            res.err = s3DeleteRes.err;
        }
    }
    else {
        res.err = new Error(`No usable metadata`);
    }
    return res;
};
